var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full col-span-full",
    on: {
      "mousedown": function ($event) {
        _vm.isDragging = true;
      },
      "mouseleave": function ($event) {
        _vm.isDragging = false;
      },
      "mouseup": function ($event) {
        _vm.isDragging = false;
      }
    }
  }, [_vm.libelle ? _c('info-bulle', {
    attrs: {
      "libelle": _vm.labelLibelle,
      "name": _vm.name,
      "is-libelle-input": true
    },
    scopedSlots: _vm._u([{
      key: "libelleBefore",
      fn: function () {
        return [_c('p', {
          staticClass: "text-sm text-gray-600 truncate mb-2",
          style: _vm.inherits != undefined && _vm.inherits != null && _vm.inherits ? 'color: inherit; font-size: inherit; font-weight: inherit;' : '',
          attrs: {
            "for": _vm.name
          },
          domProps: {
            "innerHTML": _vm._s(_vm.textLibelle)
          },
          on: {
            "mouseover": function ($event) {
              _vm.tooltipLibelle = true;
            },
            "mouseleave": function ($event) {
              _vm.tooltipLibelle = false;
            }
          }
        }), _vm.required ? _c('span', {
          staticClass: "text-pink-600 ml-1"
        }, [_vm._v("*")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "tooltipLibelleBefore",
      fn: function () {
        return [_c('transition', {
          attrs: {
            "enter-active-class": "duration-300 delay-1000",
            "enter-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "duration-300",
            "leave-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }
        }, [_vm.tooltipLibelle && _vm.libelle != null && _vm.libelle != '' ? _c('div', {
          staticClass: "absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
        }, [_vm._v("\n          " + _vm._s(_vm.libelle) + "\n        ")]) : _vm._e()])];
      },
      proxy: true
    }], null, false, 2640669458)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative",
    on: {
      "mouseover": function ($event) {
        _vm.tooltipValue = true;
      },
      "mouseleave": function ($event) {
        _vm.tooltipValue = false;
      }
    }
  }, [_c('div', {
    staticClass: "absolute inset-y-0 left-0 flex items-center text-indigo-600 px-4 w-max"
  }, [_c('icon', {
    staticClass: "text-indigo-600",
    class: {
      'mr-2': _vm.prefixText.length > 0
    },
    attrs: {
      "name": "move"
    }
  }), _vm._v(" "), _vm.prefixText.length > 0 ? _c('p', {
    staticClass: "text-sm font-normal text-gray-900 pt-0.5"
  }, [_vm._v("\n        " + _vm._s(_vm.prefixText) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutableValue,
      expression: "mutableValue"
    }],
    key: _vm.isEditable,
    ref: _vm.name,
    staticClass: "border border-opacity-50 rounded-md placeholder-gray-600 block w-full focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 appearance-none transition duration-150 ease-in-out sm:leading-5 truncate",
    class: {
      'bg-gray-200 cursor-not-allowed': _vm.disabled || _vm.disabled_pass,
      'text-lg py-5 px-5': _vm.big != null && _vm.big,
      'text-sm pl-6 pr-8 py-2 xxl:pl-10 xxl:pr-8 xxl:py-3 2xl:pl-10 2xl:pr-12 2xl:py-4': _vm.big == null || !_vm.big,
      'pl-12 xxl:pl-14 2xl:pl-14': _vm.prefixText.length > 0 && _vm.prefixText.length < 4,
      'pl-12 xxl:pl-16 2xl:pl-16': _vm.prefixText.length >= 4,
      'border-red-500': _vm.error && _vm.errorMsg != '',
      'border-indigo-600': !(_vm.error && _vm.errorMsg != ''),
      'pointer-events-none': !_vm.isEditable
    },
    style: _vm.isGrabable && !_vm.isEditable ? 'cursor:grab' : '',
    attrs: {
      "name": _vm.name,
      "min": _vm.min,
      "max": _vm.max,
      "necessary": _vm.progressCount,
      "required": _vm.isRequired,
      "autocomplete": 'off',
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled || _vm.disabled_pass || !_vm.isEditable,
      "maxlength": _vm.maxlength
    },
    domProps: {
      "value": _vm.mutableValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.mutableValue = $event.target.value;
      }
    }
  }), _vm._v(" "), !(_vm.disabled || _vm.disabled_pass) && !_vm.isEditable ? _c('div', {
    staticClass: "absolute inset-y-0 right-0 flex items-center text-pink-600 px-4 cursor-pointer w-max",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.displayMenu();
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "more-vertical"
    }
  })], 1) : _vm._e(), _vm._v(" "), !(_vm.disabled || _vm.disabled_pass) && _vm.isEditable ? _c('div', {
    staticClass: "absolute inset-y-0 right-0 flex items-center cursor-pointer text-teal-400 px-4 w-max",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.switchEditable();
      }
    }
  }, [_c('icon', {
    staticClass: "text-teal-600",
    attrs: {
      "name": "checkmark-circle"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isMenuDisplayed && !_vm.isEditable ? _c('div', {
    directives: [{
      name: "clickOutside",
      rawName: "v-clickOutside",
      value: _vm.forceHide,
      expression: "forceHide"
    }],
    staticClass: "menu-input z-20 absolute -right-8 top-10 text-sm w-max bg-white rounded-md shadow-md shadow-gray-600 px-6 py-5 cursor-default flex flex-col space-y-1",
    attrs: {
      "name": 'menu' + _vm.name
    }
  }, [_c('div', {
    staticClass: "text-gray-600 hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.switchEditable();
      }
    }
  }, [_vm._v("\n        Modifier\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-gray-600 hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.duplicate();
      }
    }
  }, [_vm._v("\n        Dupliquer\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-gray-600 hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.deleteIt();
      }
    }
  }, [_vm._v("\n        Supprimer\n      ")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "duration-300 delay-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.tooltipValue && _vm.mutableValue != null && _vm.mutableValue != '' && !_vm.isDragging ? _c('div', {
    staticClass: "absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-128"
  }, [_vm._v("\n        " + _vm._s(_vm.mutableValue) + "\n      ")]) : _vm._e()])], 1), _vm._v(" "), _vm.error ? _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }